module.exports = __webpack_public_path__ + "img/1.fe3b56f3.png";